function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import platform from "../platform/index.js";
import utils from "../utils.js";
import AxiosError from "../core/AxiosError.js";
import composeSignals from "../helpers/composeSignals.js";
import { trackStream } from "../helpers/trackStream.js";
import AxiosHeaders from "../core/AxiosHeaders.js";
import { progressEventReducer, progressEventDecorator, asyncDecorator } from "../helpers/progressEventReducer.js";
import resolveConfig from "../helpers/resolveConfig.js";
import settle from "../core/settle.js";
var DEFAULT_CHUNK_SIZE = 64 * 1024;
var isFunction = utils.isFunction;

var globalFetchAPI = function (_ref) {
  var Request = _ref.Request,
      Response = _ref.Response;
  return {
    Request: Request,
    Response: Response
  };
}(utils.global);

var _utils$global = utils.global,
    ReadableStream = _utils$global.ReadableStream,
    TextEncoder = _utils$global.TextEncoder;

var test = function test(fn) {
  try {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return !!fn.apply(void 0, args);
  } catch (e) {
    return false;
  }
};

var factory = function factory(env) {
  env = utils.merge.call({
    skipUndefined: true
  }, globalFetchAPI, env);
  var _env = env,
      envFetch = _env.fetch,
      Request = _env.Request,
      Response = _env.Response;
  var isFetchSupported = envFetch ? isFunction(envFetch) : typeof fetch === 'function';
  var isRequestSupported = isFunction(Request);
  var isResponseSupported = isFunction(Response);

  if (!isFetchSupported) {
    return false;
  }

  var isReadableStreamSupported = isFetchSupported && isFunction(ReadableStream);
  var encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? function (encoder) {
    return function (str) {
      return encoder.encode(str);
    };
  }(new TextEncoder()) : /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(str) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = Uint8Array;
              _context.next = 3;
              return new Request(str).arrayBuffer();

            case 3:
              _context.t1 = _context.sent;
              return _context.abrupt("return", new _context.t0(_context.t1));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
  var supportsRequestStream = isRequestSupported && isReadableStreamSupported && test(function () {
    var duplexAccessed = false;
    var hasContentType = new Request(platform.origin, {
      body: new ReadableStream(),
      method: 'POST',

      get duplex() {
        duplexAccessed = true;
        return 'half';
      }

    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
  });
  var supportsResponseStream = isResponseSupported && isReadableStreamSupported && test(function () {
    return utils.isReadableStream(new Response('').body);
  });
  var resolvers = {
    stream: supportsResponseStream && function (res) {
      return res.body;
    }
  };
  isFetchSupported && function () {
    ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach(function (type) {
      !resolvers[type] && (resolvers[type] = function (res, config) {
        var method = res && res[type];

        if (method) {
          return method.call(res);
        }

        throw new AxiosError("Response type '".concat(type, "' is not supported"), AxiosError.ERR_NOT_SUPPORT, config);
      });
    });
  }();

  var getBodyLength = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(body) {
      var _request;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(body == null)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", 0);

            case 2:
              if (!utils.isBlob(body)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return", body.size);

            case 4:
              if (!utils.isSpecCompliantForm(body)) {
                _context2.next = 9;
                break;
              }

              _request = new Request(platform.origin, {
                method: 'POST',
                body: body
              });
              _context2.next = 8;
              return _request.arrayBuffer();

            case 8:
              return _context2.abrupt("return", _context2.sent.byteLength);

            case 9:
              if (!(utils.isArrayBufferView(body) || utils.isArrayBuffer(body))) {
                _context2.next = 11;
                break;
              }

              return _context2.abrupt("return", body.byteLength);

            case 11:
              if (utils.isURLSearchParams(body)) {
                body = body + '';
              }

              if (!utils.isString(body)) {
                _context2.next = 16;
                break;
              }

              _context2.next = 15;
              return encodeText(body);

            case 15:
              return _context2.abrupt("return", _context2.sent.byteLength);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getBodyLength(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var resolveBodyLength = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(headers, body) {
      var length;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              length = utils.toFiniteNumber(headers.getContentLength());
              return _context3.abrupt("return", length == null ? getBodyLength(body) : length);

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function resolveBodyLength(_x3, _x4) {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(config) {
      var _resolveConfig, url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, _resolveConfig$withCr, withCredentials, fetchOptions, _fetch, composedSignal, request, unsubscribe, requestContentLength, _request, contentTypeHeader, _progressEventDecorat, _progressEventDecorat2, onProgress, flush, isCredentialsSupported, resolvedOptions, response, isStreamResponse, options, responseContentLength, _ref6, _ref7, _onProgress, _flush, responseData;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _resolveConfig = resolveConfig(config), url = _resolveConfig.url, method = _resolveConfig.method, data = _resolveConfig.data, signal = _resolveConfig.signal, cancelToken = _resolveConfig.cancelToken, timeout = _resolveConfig.timeout, onDownloadProgress = _resolveConfig.onDownloadProgress, onUploadProgress = _resolveConfig.onUploadProgress, responseType = _resolveConfig.responseType, headers = _resolveConfig.headers, _resolveConfig$withCr = _resolveConfig.withCredentials, withCredentials = _resolveConfig$withCr === void 0 ? 'same-origin' : _resolveConfig$withCr, fetchOptions = _resolveConfig.fetchOptions;
              _fetch = envFetch || fetch;
              responseType = responseType ? (responseType + '').toLowerCase() : 'text';
              composedSignal = composeSignals([signal, cancelToken && cancelToken.toAbortSignal()], timeout);
              request = null;

              unsubscribe = composedSignal && composedSignal.unsubscribe && function () {
                composedSignal.unsubscribe();
              };

              _context4.prev = 6;
              _context4.t0 = onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head';

              if (!_context4.t0) {
                _context4.next = 13;
                break;
              }

              _context4.next = 11;
              return resolveBodyLength(headers, data);

            case 11:
              _context4.t1 = requestContentLength = _context4.sent;
              _context4.t0 = _context4.t1 !== 0;

            case 13:
              if (!_context4.t0) {
                _context4.next = 17;
                break;
              }

              _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
              });

              if (utils.isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
                headers.setContentType(contentTypeHeader);
              }

              if (_request.body) {
                _progressEventDecorat = progressEventDecorator(requestContentLength, progressEventReducer(asyncDecorator(onUploadProgress))), _progressEventDecorat2 = _slicedToArray(_progressEventDecorat, 2), onProgress = _progressEventDecorat2[0], flush = _progressEventDecorat2[1];
                data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
              }

            case 17:
              if (!utils.isString(withCredentials)) {
                withCredentials = withCredentials ? 'include' : 'omit';
              } // Cloudflare Workers throws when credentials are defined
              // see https://github.com/cloudflare/workerd/issues/902


              isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
              resolvedOptions = _objectSpread(_objectSpread({}, fetchOptions), {}, {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
              });
              request = isRequestSupported && new Request(url, resolvedOptions);
              _context4.next = 23;
              return isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions);

            case 23:
              response = _context4.sent;
              isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');

              if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                options = {};
                ['status', 'statusText', 'headers'].forEach(function (prop) {
                  options[prop] = response[prop];
                });
                responseContentLength = utils.toFiniteNumber(response.headers.get('content-length'));
                _ref6 = onDownloadProgress && progressEventDecorator(responseContentLength, progressEventReducer(asyncDecorator(onDownloadProgress), true)) || [], _ref7 = _slicedToArray(_ref6, 2), _onProgress = _ref7[0], _flush = _ref7[1];
                response = new Response(trackStream(response.body, DEFAULT_CHUNK_SIZE, _onProgress, function () {
                  _flush && _flush();
                  unsubscribe && unsubscribe();
                }), options);
              }

              responseType = responseType || 'text';
              _context4.next = 29;
              return resolvers[utils.findKey(resolvers, responseType) || 'text'](response, config);

            case 29:
              responseData = _context4.sent;
              !isStreamResponse && unsubscribe && unsubscribe();
              _context4.next = 33;
              return new Promise(function (resolve, reject) {
                settle(resolve, reject, {
                  data: responseData,
                  headers: AxiosHeaders.from(response.headers),
                  status: response.status,
                  statusText: response.statusText,
                  config: config,
                  request: request
                });
              });

            case 33:
              return _context4.abrupt("return", _context4.sent);

            case 36:
              _context4.prev = 36;
              _context4.t2 = _context4["catch"](6);
              unsubscribe && unsubscribe();

              if (!(_context4.t2 && _context4.t2.name === 'TypeError' && /Load failed|fetch/i.test(_context4.t2.message))) {
                _context4.next = 41;
                break;
              }

              throw Object.assign(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request), {
                cause: _context4.t2.cause || _context4.t2
              });

            case 41:
              throw AxiosError.from(_context4.t2, _context4.t2 && _context4.t2.code, config, request);

            case 42:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[6, 36]]);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};

var seedCache = new Map();
export var getFetch = function getFetch(config) {
  var env = config && config.env || {};
  var fetch = env.fetch,
      Request = env.Request,
      Response = env.Response;
  var seeds = [Request, Response, fetch];
  var len = seeds.length,
      i = len,
      seed,
      target,
      map = seedCache;

  while (i--) {
    seed = seeds[i];
    target = map.get(seed);
    target === undefined && map.set(seed, target = i ? new Map() : factory(env));
    map = target;
  }

  return target;
};
var adapter = getFetch();
export default adapter;